export const fetchProductRecordFromList = (list, name) => {
  return list.find((p) => p.fields.seriesName === name);
};
